/* global $ */

// import { throttleDomAfterAsync } from '../helpers/throttle';

// const scrollEffectDelay = 70; // delay any scroll events by this many MS
const $modules = $.$body.find('[data-module],.module');

// add class to last module
$modules.last().addClass('last-module');

// Accordians
$.$body
  .on('focus', '.accordion .js-accordion-button', (e) => {
    $(e.currentTarget).attr('aria-selected', true);
  })
  .on('blur', '.accordion .js-accordion-button', (e) => {
    $(e.currentTarget).attr('aria-selected', false);
  })
  .on('click', '.accordion .js-accordion-button', (e) => {
    e.preventDefault();

    const $button = $(e.currentTarget);
    const isExpanded = $button.attr('aria-expanded') === 'true';
    const $header = $button.closest('.accordion__headline');
    const $section = $header.next('.accordion__content');

    $button.attr('aria-expanded', !isExpanded);
    $section.attr('aria-hidden', isExpanded);

    if (!isExpanded) {
      const $rowAnchor = $header.closest('.accordion__single-row');
      window.scrollTo(0, $rowAnchor.offset().top - 95);
      // if (false && 'scrollIntoViewIfNeeded' in $rowAnchor.get(0)) {
      //   $rowAnchor.get(0).scrollIntoViewIfNeeded(false);
      // } else if (false && 'scrollIntoView' in $rowAnchor.get(0)) {
      //   $rowAnchor.get(0).scrollIntoView(true);
      // } else {
      //   window.scrollTo(0, $rowAnchor.offset().top - 95);
      // }
    }
  });

// load twitter widgets if needed
if ($.$body.find('blockquote.twitter-tweet').length) {
  $.getScript('https://platform.twitter.com/widgets.js');
}

// slider jump arrow
const sizeMove = 305; // width of one slide

$.$body.on('click', '.slider-control', (e) => {
  const $target = $(e.currentTarget);
  const $slider = $target
    .next('.slider__outer-container')
    .find('.slider__container');
  const left = $slider.scrollLeft();
  const width = $slider.innerWidth();
  const isFar = width - left < sizeMove * 3 - 2;
  console.log(left, width, { isFar });
  $slider.animate({ scrollLeft: left + sizeMove }, 800);
  if (isFar) {
    $target.parent().addClass('too-far');
  } else {
    $target.parent().removeClass('too-far');
  }
});
